




























































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ReportsModule } from '@/store/Reporting/ReportsModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import AccountType from '@/models/Shared/AccountType';
import GetSingleAccountTransactionsRequest from '@/models/Reporting/Reports/GetSingleAccountTransactionsRequest';
import DepositAccountSummary from '@/models/Accounts/DepositAccounts/DepositAccountSummary';
import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";
import InstitutionAccount from '@/models/Accounts/InstitutionAccounts/InstitutionAccount';
import ThirdPartyAccount from '@/models/Accounts/ThirdPartyAccounts/ThirdPartyAccount';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'SingleAccountReportDialog' })
export default class extends SaascadaVueDialog {

    reportFromDateAsString: string = new Date().toISOString();
    reportToDateAsString: string = new Date().toISOString();
    todaysDateAsString: string = new Date().toISOString();
    accountType: AccountType = null;
    depositAccountSelection: DepositAccountSummary = new DepositAccountSummary();
    institutionAccountSelection: InstitutionAccount = new InstitutionAccount();
    thirdPartyAccountSelection: ThirdPartyAccount = new ThirdPartyAccount();
    walletSelection: Wallet = new Wallet();
    request: GetSingleAccountTransactionsRequest = new GetSingleAccountTransactionsRequest();
    currentPage: number = 1;

    AccountType = AccountType;

    @Prop({ required: false })
    prefillAccountType: AccountType;

    @Prop({ required: false })
    prefillCustomerAccountSelection: DepositAccountSummary;

    @Prop({ required: false })
    prefillInstitutionAccountSelection: InstitutionAccount;

    @Prop({ required: false })
    prefillThirdPartyAccountSelection: ThirdPartyAccount;

    @Prop({ required: false })
    prefillWalletSelection: Wallet;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // Reset field values back to default
            this.currentPage = 1;
            this.depositAccountSelection = new DepositAccountSummary();
            this.institutionAccountSelection = new InstitutionAccount();
            this.thirdPartyAccountSelection = new ThirdPartyAccount();
            this.walletSelection = new Wallet();
            // Apply any prefilled fields, some depend on the account type
            this.accountType = this.prefillAccountType;
            if (this.accountType === AccountType.Customer) {
                this.depositAccountSelection = this.prefillCustomerAccountSelection;
                this.walletSelection = this.prefillWalletSelection;
            }
            if (this.accountType === AccountType.Institution) {
                this.institutionAccountSelection = this.prefillInstitutionAccountSelection;
            }
            if (this.accountType === AccountType.ThirdParty) {
                this.thirdPartyAccountSelection = this.prefillThirdPartyAccountSelection;
            }
            // Calculate the maximum toDate of the report which should be today at the
            // latest because can't run a report in the future
            const date = new Date();
            this.todaysDateAsString = date.toISOString().split('T')[0];
            // Initialise the base fromDate and toDate as today, where the fromDate has a
            // max value of the toDate, because you can't have a fromDate after the toDate
            const today = new Date();
            this.reportFromDateAsString = today.toISOString().split('T')[0];
            this.reportToDateAsString = today.toISOString().split('T')[0];
        }
    }

    @Watch('accountType')
    async onAccountTypeChanged(accountType: AccountType) {
        if (accountType === AccountType.Customer) {
            await ReportsModule.getDepositAccountsForReport();
        }
        if (accountType === AccountType.Institution) {
            await ReportsModule.getInstitutionAccountsForReport();
        }
        if (accountType === AccountType.ThirdParty) {
            await ReportsModule.getThirdPartyAccountsForReport();
        }
    }

    @Watch('depositAccountSelection')
    async onCustomerAccountSelectionChanged(depositAccount: DepositAccountSummary) {
        if (depositAccount && depositAccount.id) {
            await ReportsModule.getDepositAccountWalletsForReport(this.depositAccountSelection.id);
        }
        else {
            // Reset values when the depositAccountSelection has been cleared
            this.walletSelection = new Wallet();
        }
    }

    get accountTypeOptions() {
        return ListUtils.accountTypeOptionsLongList();
    }

    get loadingReport() {
        return ReportsModule.loadingReport;
    }

    get loadingReportFailed() {
        return ReportsModule.loadingReportFailed;
    }

    get depositAccountsForReport() {
        return ReportsModule.depositAccountsForReport;
    }

    get depositAccountWalletsForReport() {
        return ReportsModule.depositAccountWalletsForReport;
    }

    get institutionAccountsForReport() {
        return ReportsModule.institutionAccountsForReport;
    }

    get thirdPartyAccountsForReport() {
        return ReportsModule.thirdPartyAccountsForReport;
    }

    get loadingAccountsForReport() {
        return ReportsModule.loadingAccountsForReport;
    }

    cancel() {
        this.dialog = false;
    }

    downloadReport () {
        let accountNameNoSpaces;
        let downloadLink;

        // Work out the account name depending on the selected account type and
        // remove whitespace for safety as it will be used in the filename
        if (this.accountType === AccountType.Customer) {
            accountNameNoSpaces = this.depositAccountSelection.name.replace(/\s+/g, '');
        }
        if (this.accountType === AccountType.Institution) {
            accountNameNoSpaces = this.institutionAccountSelection.name.replace(/\s+/g, '');
        }
        if (this.accountType === AccountType.ThirdParty) {
            accountNameNoSpaces = this.thirdPartyAccountSelection.name.replace(/\s+/g, '');
        }

        downloadLink = document.getElementById(`${accountNameNoSpaces}-transactions-report-from-${this.reportFromDateAsString}-to-${this.reportToDateAsString}.csv`);
        downloadLink.click();
    }

    async run() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.currentPage = 2;

            // Build the request, note some fields are specific based on the account type
            this.request.fromDate = this.reportFromDateAsString;
            this.request.toDate = this.reportToDateAsString;

            if (this.accountType === AccountType.Customer) {
                this.request.accountId = this.depositAccountSelection.id;
                this.request.accountName = this.depositAccountSelection.name;
                this.request.walletId = this.walletSelection.id;
                await ReportsModule.getCustomerAccountTransactionsProjection(this.request);
            }
            if (this.accountType === AccountType.Institution) {
                this.request.accountId = this.institutionAccountSelection.id;
                this.request.accountName = this.institutionAccountSelection.name;
                await ReportsModule.getInstitutionAccountTransactionsProjection(this.request);
            }
            if (this.accountType === AccountType.ThirdParty) {
                this.request.accountId = this.thirdPartyAccountSelection.id;
                this.request.accountName = this.thirdPartyAccountSelection.name;
                await ReportsModule.getThirdPartyAccountTransactionsProjection(this.request);
            }
        }
    }

}
